/**
 * The messages an operator can send themselves from Settings, to see what a
 * customer receives. One list, read by the worker's validation and the
 * screen's picker, so a template added to one cannot be missing from the other.
 */
export const TEST_MAIL_TEMPLATES = ["order_code", "underpaid", "delivery", "topup"];
/** Across every administrator: the reputation being spent is the shop's. */
export const TEST_MAILS_PER_HOUR = 20;
/** Marks a test in the subject, where an inbox search and a filter look. */
export const TEST_SUBJECT_PREFIX = "[Test] ";
export const isTestMailTemplate = (v) => TEST_MAIL_TEMPLATES.includes(v);
//# sourceMappingURL=test-mail.js.map